import { gql } from "@apollo/client";

export const LESSON_PRE_REG = gql`
    query lessonPreReg {
        lessonPreReg {
            title
            videoLink
        }
    }
`;

export const LESSON = gql`
    query lesson($id: ID!) {
        lesson(id: $id) {
            lessonId
            lessonNumber
            title
            description
            publishStatus
            qaLink
            pdfLink
            audioLink
            videoLink
            summaryLink
            subtitleLink
            details
            hasAssignment
            hasCommitment
            assignmentDescription
            isFinale
            createdAt
            updatedAt

            course {
                configs {
                    examMinRequiredScore
                    examFailureCharge
                    examAbsenceCharge
                    lessonAbsenceCharge
                }
            }

            userHasPendingWarning
            warning {
                warningId
                status
                reason
                createdAt

                warningCount
                finalCharge
            }
            donationEnabled
        }
    }
`;

export const LESSONS = gql`
    query lessons($course: ID!, $first: Int, $after: String) {
        lessons(course: $course, first: $first, after: $after) {
            totalCount
            pageInfo {
                hasNextPage
                endCursor
            }
            edges {
                node {
                    title
                    lessonId
                    lessonNumber
                    isFinale
                    probablyActive {
                        isActive
                        reason
                    }
                    lessonProgress {
                        status
                        createdAt
                        localizedCreatedAt
                        completedAt
                        localizedCompletedAt
                    }
                }
            }
        }
    }
`;

export const LESSON_ACTIVE_NUMBER = gql`
    query lessonActiveNumber($course: ID!) {
        lessonActiveNumber(course: $course)
    }
`;

export const LESSON_GROUPS = gql`
    query lessonGroups($courseId: ID) {
        lessonGroups(courseId: $courseId) {
            title
            order
            number
            lessonGroupId
            isFinished
            progressPercentage
            lessons {
                lessonId
                lessonNumber
            }
        }
    }
`;

export const LESSON_PREVIEWS_GROUP = gql`
    query lessonPreviewsGroup($groupId: ID!, $courseId: ID) {
        lessonPreviewsGroup(groupId: $groupId, courseId: $courseId) {
            previews {
                title
                lessonId
                lessonNumber
                details
                probablyActive {
                    isActive
                    reason
                }
                lessonProgress {
                    status
                    createdAt
                    localizedCreatedAt
                    completedAt
                    localizedCompletedAt
                    isAbleToOpenNewLesson
                }
            }
        }
    }
`;
